import React, { useState } from "react";

const ListDropdown = ({ joinPatientInRoom, items }) => {
  const [selectedId, setSelectedId] = useState("");

  const handleChange = (e) => {
    setSelectedId(e.target.value);
  };

  const handleJoin = () => {
    if (selectedId) {
      joinPatientInRoom(selectedId);
    }
  };

  return (
    <div className="container my-3">
      <div className="d-flex gap-3 align-items-center justify-content-between">
        {/* <h6 className="mb-2">Select Group</h6> */}

        <select
          className="form-select  "
          value={selectedId}
          onChange={handleChange}
        >
          <option value="">-- Select Prayer Room--</option>
          {items?.map((item) => (
            <option key={item?.id} value={item?.id}>
              {item?.name}
            </option>
          ))}
        </select>

        <button
          className="btn btn-primary"
          onClick={handleJoin}
          disabled={!selectedId}
        >
          Join
        </button>
      </div>
    </div>
  );
};

export default ListDropdown;
